import Swiper, { Navigation } from "swiper"
Swiper.use([Navigation])
export default new (class VacancyCarousel {
    constructor() {
        this.sliderContainerSelector = "carousel-vacancy"
        this.sliderNextSelector = "carousel-vacancy-next"
        this.sliderPrevSelector = "carousel-vacancy-prev"
        this.handler()
    }

    handler() {
        const slider = document.querySelector(`.${this.sliderContainerSelector}`)

        if (!slider) return

        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        document.querySelectorAll(`.${this.sliderContainerSelector}`).forEach((item) => {
            new Swiper(item, {
                slidesPerView: 1,
                spaceBetween: 20,
                navigation: {
                    nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                },
                centerInsufficientSlides: true,
            })
        })
    }
})()
